<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Civil Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Faculty'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Faculty</div>
          <faculty-card class="mb-5"
                        v-for="(faculty, index) in facultyList"
                        :key="index"
                        :faculty="faculty"
                        :dir="dirName"></faculty-card>

        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/civil/Sidebar";
import FacultyCard from "@/components/FacultyCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Faculty",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    FacultyCard,
    KeyRecruiters
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      dirName: 'civil',
      facultyList: [
        {
          name: 'Prof Gawali.N.B',
          cv: 'test.pdf',
          image: 'gawali_n_b',
          designation: 'HOD, Assistant Professor',
          qualification: 'M.E ',
          experience: '10 Years',
          specialization: 'Structural Engineering',
          contact: '9970079320',
          email: 'gawalinileshce@gmail.com'
        },
        {
          name: 'Prof. Ansari.U.S',
          cv: 'test.pdf',
          image: 'anasari_u_s',
          designation: 'Assistant Professor',
          qualification: 'M.E .Ph.D*',
          experience: '11 Years',
          specialization: 'Hydraulic Structure',
          contact: '9970768662',
          email: 'ansariubaids@gmail.com '
        },
        {
          name: 'Prof. Karale.S.A',
          cv: 'test.pdf',
          image: 'karale_s_a',
          designation: 'Assistant Professor',
          qualification: 'M.E .Ph.D*',
          experience: '11.5 Years',
          specialization: 'Environmental Engineering',
          contact: '9860305612',
          email: 'sandipakarale@gmail.com '
        },
        {
          name: 'Prof. Nikam.P.A',
          cv: 'test.pdf',
          image: 'nikam_p_a',
          designation: 'Assistant Professor',
          qualification: 'M.E ',
          experience: '11 Years',
          specialization: 'Structural Engineering',
          contact: '7588097187',
          email: 'pravinnikam16@gmail.com '
        },
        {
          name: 'Prof. Kulkarni.V.K',
          cv: 'test.pdf',
          image: 'kulakarni_v_k',
          designation: 'Assistant Professor',
          qualification: 'M.E ',
          experience: '35 Years',
          specialization: 'Construction Managment',
          contact: '7387145165',
          email: 'vivekkulkarni273@gmail.com '
        },
        {
          name: 'Prof. Sanap.S.T',
          cv: 'test.pdf',
          image: 'sanap_s_t',
          designation: 'Assistant Professor',
          qualification: 'M.E ',
          experience: '8 Years',
          specialization: 'Environmental Engineering',
          contact: '9975577180',
          email: 'santoshsanap.56@gmail.com '
        },
        {
          name: 'Prof. Pote.R.K',
          cv: 'test.pdf',
          image: 'pote_p_k',
          designation: 'Assistant Professor',
          qualification: 'M.E .Ph.D*',
          experience: '7 Years',
          specialization: 'Structural Engineering',
          contact: '9579446575',
          email: 'rohitpote92@gmail.com'
        },
        {
          name: 'Prof. Kasliwal.S.S',
          cv: 'test.pdf',
          image: 'kaisawal_s_s',
          designation: 'Assistant Professor',
          qualification: 'M.E ',
          experience: '7 Years',
          specialization: 'Structural Engineering',
          contact: '9028126721',
          email: 'saurabhkasliwal1993@gmail.com '
        },
        {
          name: 'Prof. Gawande.Y.B',
          cv: 'test.pdf',
          image: 'gawande_y_b',
          designation: 'Assistant Professor',
          qualification: 'M.E ',
          experience: '7 Years',
          specialization: 'Structural Engineering',
          contact: '9665491009',
          email: 'ybg1991@gmail.com '
        },
        {
          name: 'Mr. Pagare.S.U',
          cv: 'test.pdf',
          image: 'parag_s_u',
          designation: 'Technical Assistant',
          qualification: 'B.E',
          experience: '5 Years',
          specialization: 'Civil Engineering',
          contact: '9922902897',
          email: 'pagaresunil30@gmail.com '
        },
        {
          name: 'Mrs Bhavar A.N',
          cv: 'test.pdf',
          image: 'bhavar_a_n',
          designation: 'Technical Assistant',
          qualification: 'Diploma',
          experience: '1 Years',
          specialization: 'Civil Engineering',
          contact: '9529857541',
          email: 'None'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
